import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import CircularChart from "./CircularChart";
import FileService from "../../services/fileService";
import "./UserResourceSummary.scss";
import { generateUniqueId } from "../../utils";

const UserResourceSummary = ({ resource_summary, isNightMode }) => {
  const assignedTo = useMemo(
    () => resource_summary?.[0]?.assigned_to,
    [resource_summary]
  );
  const billableHrs = useMemo(() => {
    const billable = resource_summary.reduce(
      (acc, curr) => acc + curr.billable_hrs,
      0
    );
    return billable;
  }, [resource_summary]);

  const topProjects = useMemo(() => {
    const projects = resource_summary.slice(
      0,
      resource_summary.length > 5 ? 5 : resource_summary.length
    );
    return projects;
  }, [resource_summary]);

  const workedHrs = useMemo(() => {
    const actual = resource_summary.reduce(
      (acc, curr) => acc + curr.actual_hrs,
      0
    );
    return actual;
  }, [resource_summary]);

  const percentage = useMemo(() => {
    const result = (workedHrs * 100) / 40;
    return result || 0;
  }, [workedHrs]);

  const initials = useMemo(
    () =>
      assignedTo?.full_name
        ? assignedTo.full_name.split(" ").map((n) => n.charAt(0))
        : [],
    [assignedTo]
  );

  const [imageSrc, setImageSrc] = useState(null);

  const token = localStorage.getItem("grav_token");
  const fileName = assignedTo?.avatar?.replace(
    "https://gfs-redkeep.s3.amazonaws.com/",
    ""
  );

  useEffect(() => {
    const fetchImage = async () => {
      const imageSource = await FileService.getFileWithToken(fileName, token);
      setImageSrc(imageSource);
    };
    if (token.length && fileName) {
      fetchImage();
    }
  }, [token, fileName]);

  return (
    <div
      className={`resource-summary content-wrapper ${
        isNightMode ? "dark" : "light"
      }`}
    >
      <div className="summary-info">
        <h2>{assignedTo?.full_name}</h2>
        <table
          className={`resource-summary-table ${isNightMode ? "dark" : "light"}`}
        >
          <thead>
            <th>Top Projects</th>
            <th>Hours</th>
          </thead>
          <tbody>
            {topProjects.map((item) => (
              <tr
                key={generateUniqueId()}
                className={isNightMode ? "dark" : "light"}
              >
                <td>
                  {item.customer.name} - {item.project.name}
                </td>
                <td>{item.actual_hrs}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <table
          className={`resource-summary-table main-summary ${
            isNightMode ? "dark" : "light"
          }`}
        >
          <thead>
            <th>Hours worked</th>
            <th>{workedHrs}</th>
          </thead>
          <tbody>
            <tr className={isNightMode ? "dark" : "light"}>
              <td>Billable</td>
              <td>{billableHrs}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="profile-picture">
        {assignedTo?.avatar ? (
          <img src={imageSrc} alt="" />
        ) : (
          <div className="user-icon">
            <span>{initials.join("")}</span>
          </div>
        )}
        <CircularChart
          className="circular-chart animate"
          percentage={percentage}
          size={250}
        >
          <svg role="img" xmlns="http://www.w3.org/2000/svg">
            <circle className="circle-background" />
            <circle className="circle-foreground" />
          </svg>
        </CircularChart>
      </div>
    </div>
  );
};
UserResourceSummary.propTypes = {
  resource_summary: PropTypes.array,
  isNightMode: PropTypes.bool
};
export default UserResourceSummary;
